import{jsx as r}from"react/jsx-runtime";import{twJoin as e}from"tailwind-merge";import{Box as t}from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";import{NewCircle as s}from"./parts/NewCircle.js";import{New as a}from"./parts/New.js";import{Beta as i}from"./parts/Beta.js";import{Ai as o}from"./parts/Ai.js";import"react";
/**
 * 이미지에 오버레이되는 라벨을 표시하는 컴포넌트
 * @param {('new_circle'|'new'|'beta'|'ai')} props.type - 표시할 라벨의 타입
 * @returns {JSX.Element} 라벨 컴포넌트
 * @example
 * // NEW 원형 라벨
 * <ImageLabel type="new_circle" />
 *
 * // NEW 라벨
 * <ImageLabel type="new" />
 *
 * // BETA 라벨
 * <ImageLabel type="beta" />
 *
 * // AI 라벨
 * <ImageLabel type="ai" />
 *
 */const m=({type:m})=>{const p=()=>{switch(m){case"new_circle":/*#__PURE__*/
return r(s,{});case"new":/*#__PURE__*/
return r(a,{});case"beta":/*#__PURE__*/
return r(i,{});case"ai":/*#__PURE__*/
return r(o,{});default:return null}};/*#__PURE__*/
return r(t,{"data-testid":"design-system-imageLabel",className:e("h-fit w-fit text-primary","new_circle"!==m&&"pb-1.5"),children:/*#__PURE__*/r(p,{})})};export{m as ImageLabel};
